const SET_APO_CNTR_HDWT_INFO = "SET_APO_CNTR_HDWT_INFO";
const SET_APO_CNTR_HDWT_DATA = "SET_APO_CNTR_HDWT_DATA";
const CHG_APO_CNTR_HDWT_DATA = "CHG_APO_CNTR_HDWT_DATA";
const SET_MODIFY_APO_CNTR_HDWT_DATA = "SET_MODIFY_APO_CNTR_HDWT_DATA";
const SET_APO_CNTR_AGREE_INFO = "SET_APO_CNTR_AGREE_INFO";
const SET_APO_CNTR_AGREE_DATA = "SET_APO_CNTR_AGREE_DATA";
const CHG_APO_CNTR_AGREE_DATA = "CHG_APO_CNTR_AGREE_DATA";

const initialState = {
  isFirst: true,
  apoCntrHdwtInfo: [],
  apoCntrAgrInfo: [],
};

const apoCntrForm = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case SET_APO_CNTR_HDWT_INFO:
      const _apoCntrHdwtInfo = [];
      let { info, hdwtInfoIsFirst } = rest.payload;

      info.map((item) => {
        _apoCntrHdwtInfo.push({
          hdwtCatCd: item.HDWT_CAT_CD,
          text: item.HDWT_TEXT,
          signYn: item.SIGN_YN,
          data: '',
          update: false,
        })
      })

      return {
        ...state,
        isFirst: hdwtInfoIsFirst ? false : state.isFirst,
        apoCntrHdwtInfo: _apoCntrHdwtInfo,
      };
    case SET_APO_CNTR_HDWT_DATA:
      const { hdwtData, isFirst } = rest.payload;

      let _apoCntrHdwtData = state.apoCntrHdwtInfo.map((item) => {
        let temp = hdwtData.filter((item2) => item.hdwtCatCd === item2.HDWT_CAT_CD);

        if(temp.length) {
            return {
              ...item,
              data:temp[0].IMG_DATA,
              update: isFirst ? false : true,
            };
          } else {
            return item;
          }
      })

      return {
        ...state,
        isFirst: isFirst ? false : state.isFirst,
        apoCntrHdwtInfo: _apoCntrHdwtData,
      };
    case CHG_APO_CNTR_HDWT_DATA:
      let { chgData } = rest.payload;

      const chgApoCntrHdwtInfo = state.apoCntrHdwtInfo.map((item) => {
        return item.hdwtCatCd === chgData.hdwtCatCd
          ? { ...item, data: chgData.data, update: true }
          : item;
      });
      return {
        ...state,
        apoCntrHdwtInfo: chgApoCntrHdwtInfo,
      };
    case SET_MODIFY_APO_CNTR_HDWT_DATA:
      const __apoCntrHdwtInfo = state.apoCntrHdwtInfo.map((item) => {
        return item.hdwtCatCd === rest.payload.hdwtCatCd
          ? { ...item, data: undefined, update: false }
          : item;
      });
      return {
        ...state,
        apoCntrHdwtInfo: __apoCntrHdwtInfo,
      };
    case SET_APO_CNTR_AGREE_INFO:
      const _apoCntrAgrInfo = [];
      let { agrInfo } = rest.payload;

      agrInfo.map((item) => {
        _apoCntrAgrInfo.push({
          fileSeqNo: item.FILE_SEQ_NO,
          agrCatCd: item.AGR_CAT_CD,
          agrYn: item.AGR_YN,
          data: '',
        })
      })
    
      return {
        ...state,
        apoCntrAgrInfo: _apoCntrAgrInfo,
      };
    case SET_APO_CNTR_AGREE_DATA:
      const { agrData } = rest.payload;
      
      let _apoCntrAgrData = state.apoCntrAgrInfo.map((item) => {
        return {
          ...item,
          data: agrData.AGREE_YN,
        };
      })

      return {
        ...state,
        apoCntrAgrInfo: _apoCntrAgrData,
      };


      // return {
      //   ...state,
      //   apoCntrAgrInfo: state.apoCntrAgrInfo.map(item => ({
      //     ...item,
      //     data: agrData.agreeYn,
      //   })),
      // };
    case CHG_APO_CNTR_AGREE_DATA:
      let { chgAgr } = rest.payload;

      const chgApoCntrAgrData = state.apoCntrAgrInfo.map((item) => {
        return item.fileSeqNo === chgAgr.fileSeqNo
        ? { ...item, data: chgAgr.data }
        : item;
      });

      return {
        ...state,
        apoCntrAgrInfo: chgApoCntrAgrData,
      };
    case "persist/PURGE":
      return initialState;
    default:
      return state;
  }
};

export const setApoCntrHdwtInfo = (info, hdwtInfoIsFirst) => ({
  type: SET_APO_CNTR_HDWT_INFO,
  payload: { info, hdwtInfoIsFirst },
});
export const setApoCntrHdwtData = (hdwtData, isFirst) => ({
  type: SET_APO_CNTR_HDWT_DATA,
  payload: { hdwtData, isFirst },
});
export const chgApoCntrHdwtData = (chgData) => ({
  type: CHG_APO_CNTR_HDWT_DATA,
  payload: { chgData },
});
export const setModifyApoCntrHdwtData = (hdwtCatCd) => ({
  type: SET_MODIFY_APO_CNTR_HDWT_DATA,
  payload: { hdwtCatCd },
});
export const setApoCntrAgrInfo = (agrInfo) => ({
  type: SET_APO_CNTR_AGREE_INFO,
  payload: { agrInfo },
});
export const setApoCntrAgrData = (agrData) => ({
  type: SET_APO_CNTR_AGREE_DATA,
  payload: { agrData },
});
export const chgApoCntrAgrData = (chgAgr) => ({
  type: CHG_APO_CNTR_AGREE_DATA,
  payload: { chgAgr },
});

export default apoCntrForm;
